/**
 * Same ID (25) as Cores UnserializableEntityComponent that is not yet exposed
 * to be used by us. When that is fixed that can be used instead and this can be removed
 */
class UnserializableEntityComponent {
    constructor() {
        this.typeId = UnserializableEntityComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
UnserializableEntityComponent.id = 25;
export default UnserializableEntityComponent;
//# sourceMappingURL=UnserializableEntityComponent.js.map